import { Component } from '@angular/core';

@Component({
  selector: 'app-loading5',
  templateUrl: './loading5.component.html',
  styleUrls: ['./loading5.component.scss']
})
export class Loading5Component {

}
